// test2995
(2995 && 0);
